export function chartPipe(type?: string) {
  return (options: Highcharts.Options): Highcharts.Options => ({
    ...options,
    chart: {
      animation: false,
      type,
      inverted: false,
    },
  });
}